(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  function getWrapper(sectionElement) {
    return sectionElement.closest('.shopify-section') || sectionElement;
  }

  function ensureStickyStack() {
    const infoWrapper = document.querySelector('.product__info-wrapper');
    const infoContainer = document.querySelector('.product__info-container');

    if (!infoWrapper || !infoContainer) return null;

    let stack = infoWrapper.querySelector('.bitstudio-product-sidebar-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'bitstudio-product-sidebar-stack product__column-sticky';
      infoWrapper.insertBefore(stack, infoContainer);
      stack.appendChild(infoContainer);
    }

    return stack;
  }

  function ensurePlaceholder(wrapper) {
    if (wrapper.dataset.pdpInfoCarouselPlaceholderId) {
      return document.getElementById(wrapper.dataset.pdpInfoCarouselPlaceholderId);
    }

    const placeholder = document.createElement('div');
    const placeholderId = `PdpInfoCarouselPlaceholder-${Math.random().toString(36).slice(2, 10)}`;
    placeholder.id = placeholderId;
    placeholder.hidden = true;
    wrapper.parentNode.insertBefore(placeholder, wrapper);
    wrapper.dataset.pdpInfoCarouselPlaceholderId = placeholderId;
    return placeholder;
  }

  function moveCarousel(sectionElement) {
    const wrapper = getWrapper(sectionElement);
    const placeholder = ensurePlaceholder(wrapper);
    const target = ensureStickyStack();

    if (!target) return;

    if (desktopQuery.matches) {
      if (wrapper.parentNode !== target) {
        target.appendChild(wrapper);
      }
      sectionElement.classList.add('pdp-info-carousel--sidebar');
      return;
    }

    if (placeholder.parentNode && wrapper.parentNode !== placeholder.parentNode) {
      placeholder.parentNode.insertBefore(wrapper, placeholder.nextSibling);
    }
    sectionElement.classList.remove('pdp-info-carousel--sidebar');
  }

  function syncAll() {
    document.querySelectorAll('.pdp-info-carousel[data-sidebar-relocate="true"]').forEach(moveCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }

  desktopQuery.addEventListener('change', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
})();
